import React from "react"
import PropTypes from "prop-types"
import moment from "moment"
import { get } from "lodash"
import { SmallText } from "@4cplatform/elements/Typography"

// Components
import { DisclosureWrapper, DisclosureBody, DisclosureHeader, FlexRow } from "./policies.styles"

const questions = {
  // FMU Disclosures
  specialist_admissions_illness_last_5_years:
    "Have you or any person included in this application consulted with a specialist, been admitted to hospital or nursing home, or suffered from intermittent or recurrent illness during the last five years?",
  seen_medical_practitioner_last_12_months:
    "Have you or any person included in this application seen a medical practitioner in the past year? This includes a doctor, physiotherapist, practice nurse etc",
  medical_conditions:
    "Have you or any person included in this application had any medical condition, disability or health problem, not mentioned above, whether or not a doctor has been consulted, for example, gynaecological or menstrual problems, complications of pregnancy, signs or varicose veins, back trouble, joint disorders, joint replacements, foot problems (eg bunions), indigestion or bowel problems, abdominal pain, skin problems allergies, anxiety, depression or other psychiatric problems, trouble with heart, limbs, ears, eyes, urination etc?"
}

const AxaDisclosure = ({ data }) => (
  <DisclosureWrapper>
    <DisclosureHeader>
      <SmallText appearance="light" margin="0">
        {get(questions, `${data.field}`)}
      </SmallText>
    </DisclosureHeader>
    <DisclosureBody>
      <FlexRow margin="0.5rem 0">
        <SmallText appearance="light" margin="0 1rem 0 0" width="calc(50% - 1rem)">
          Nature of illness / disability and treatment received:
        </SmallText>
        <SmallText appearance="light" margin="0" width="50%" align="right">
          {data.illness_disability_treatment_received}
          {data.illness_disability}
          {data.treatment_received}
        </SmallText>
      </FlexRow>
      <FlexRow margin="0.5rem 0">
        <SmallText appearance="light" margin="0 1rem 0 0" width="calc(50% - 1rem)">
          When the illness / disability began:
        </SmallText>
        <SmallText appearance="light" margin="0" width="50%" align="right">
          {data.date_illness_began
            ? moment.utc(data.date_illness_began).local().format("DD/MM/YYYY")
            : "-"}
        </SmallText>
      </FlexRow>
      <FlexRow margin="0.5rem 0">
        <SmallText appearance="light" margin="0 1rem 0 0" width="calc(50% - 1rem)">
          When the illness / disability ended:
        </SmallText>
        <SmallText appearance="light" margin="0" width="50%" align="right">
          {data.date_illness_ended
            ? moment.utc(data.date_illness_ended).local().format("DD/MM/YYYY")
            : "-"}
        </SmallText>
      </FlexRow>
      {data.present_state_of_health != null && (
        <FlexRow margin="0.5rem 0">
          <SmallText appearance="light" margin="0 1rem 0 0" width="calc(50% - 1rem)">
            Present state of health:
          </SmallText>
          <SmallText appearance="light" margin="0" width="50%" align="right">
            {data.present_state_of_health}
          </SmallText>
        </FlexRow>
      )}

      {data.cont_cover_terms_details != null && (
        <FlexRow margin="0.5rem 0">
          <SmallText appearance="light" margin="0 1rem 0 0" width="calc(50% - 1rem)">
            Details of planned/pending consultations, tests or treatment:
          </SmallText>
          <SmallText appearance="light" margin="0" width="50%" align="right">
            {data.cont_cover_terms_details}
          </SmallText>
        </FlexRow>
      )}
    </DisclosureBody>
  </DisclosureWrapper>
)

AxaDisclosure.propTypes = {
  data: PropTypes.object.isRequired
}

export default AxaDisclosure
